export const sendVote = async (site_id, request_uri, vote) => {
  const formData = new FormData();
  formData.append('site_id', site_id);
  formData.append('request_uri', request_uri);
  formData.append('vote', vote);

  return fetch('https://visitor.natu.care/send-vote', {
    method: 'POST',
    body: formData
  });
};
